import React, { useState, useRef } from 'react';

import Tooltip from 'components/Tooltips/FloaterInf';
import useStoreTranslation from 'hooks/useStoreTranslation';

import { Tag } from './styles';

interface Props {
  reason: string | string[];
  brightColor?: boolean;
  noIcon?: boolean;
}

const BreakTag = ({ reason, brightColor, noIcon }: Props) => {
  const { t } = useStoreTranslation();

  const [showTooltip, setShowTooltip] = useState(false);

  const generateID = () => String(Math.ceil(Math.random() * 46656));

  const idRef = useRef(`break-tag-${generateID()}`);

  const toggleTooltip = (event: React.SyntheticEvent) => {
    if (event) {
      event.stopPropagation();
    }
    if (reason && Array.isArray(reason) && reason.length > 1) {
      setShowTooltip(!showTooltip);
    }
  };

  const tooltipContent = () => (
    <div>
      <span>{t('tags.breakTag.tooltip')}</span>
      <ul>
        {reason &&
          Array.isArray(reason) &&
          reason.map((item, index) => (
            <li key={index}>
              <span>{item}</span>
            </li>
          ))}
      </ul>
    </div>
  );

  const makesBreakTag = () =>
    !Array.isArray(reason)
      ? reason
      : t(reason.length > 1 ? 'tags.breakTag.reasons' : 'tags.breakTag.reason', {
          firstReason: reason.first(),
          count: reason.length - 1,
        });

  return (
    <>
      {reason.length > 0 && (
        <Tag
          id={idRef.current}
          styledProps={{
            isOpen: showTooltip,
            brightColor: !!brightColor,
            noIcon,
          }}
          onClick={toggleTooltip}
        >
          {makesBreakTag()}
        </Tag>
      )}
      {showTooltip && <Tooltip onClose={toggleTooltip} content={tooltipContent()} target={idRef.current} />}
    </>
  );
};

export default BreakTag;
